import * as React from 'react';
import { useState } from 'react';

import './style.scss';

const AchievementCard = props => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleClick = e => {
    if (typeof window !== `undefined` && window.innerWidth > 1024) {
      e.preventDefault();
    }

    setIsFlipped(!isFlipped);
  };

  return (
    <div data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
      <div
        className="achievement-card-anchor"
        // id={`achievement_${props.id}`}
        />
      <div
        role="button"
        tabIndex={0}
        className={`achievement-card ${isFlipped ? 'is-flipped' : ''}`}
        onClick={handleClick}
        onKeyDown={handleClick}
      >
        <div className="card-inner">
          <div className="front">
            <div className="subtitle">{props.subtitle}</div>
            <h3 className="front-title">{props.title}</h3>
            <div className="flip-toggle">View achievements</div>
          </div>

          <div className="back">
            <h4 className="back-title">Achievements</h4>
            <ul>
              {props.achievements.map((achievement, i) => (
                <li key={i}>{achievement}</li>
              ))}
            </ul>
            <div className="flip-toggle">Close</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementCard;
